import { COMPANY_DOCUMENTS_QUERY_KEY } from "./constants";

import type { CompanyDocumentView } from "./types";
import type { QueryClient } from "@tanstack/react-query";

export function setCompanyDocumentInCache(queryClient: QueryClient, document: CompanyDocumentView) {
  queryClient.setQueriesData<CompanyDocumentView[]>(
    { queryKey: COMPANY_DOCUMENTS_QUERY_KEY },
    (documents) => {
      if (!documents) {
        return [document];
      }

      const documentIndex = documents.findIndex(
        (existingDocument) => existingDocument.companyDocumentId === document.companyDocumentId
      );

      if (documentIndex === -1) {
        return [document, ...documents];
      }

      const updatedDocuments = [...documents];

      updatedDocuments[documentIndex] = document;

      return updatedDocuments;
    }
  );
}
